import React, { useState } from 'react';
import Sidebar from '../../components/Sidebar';
import { Outlet } from "react-router-dom";
import Header from '../../components/Header';
import PageContainer from '../../components/PageContainer';

const ManageOrders = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="h-screen w-full flex overflow-hidden bg-white">
      
      {/* SIDEBAR */}
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
      />

      {/* RIGHT SIDE */}
      <div className="flex-1 flex flex-col overflow-hidden">

        {/* HEADER (fixed) */}
        <Header onMenuClick={() => setSidebarOpen((s) => !s)} />

        {/* 🔥 SCROLL CONTAINER */}
        <main className="flex-1 overflow-y-auto">
          <PageContainer>
            <Outlet />
          </PageContainer>
        </main>

      </div>
    </div>
  );
};

export default ManageOrders;
